<script lang="ts">
import { onMount } from 'svelte'

import WidgetBranding from '@/components/branding/WidgetBranding.svelte'
import FlashMessageContainer from '@/components/flashMessage/FlashMessageContainer.svelte'
import { testIds } from '@/constants'
import DrawerManager from '@/frames/messenger/drawers/DrawerManager.svelte'
import { dragAndDrop } from '@/modules/app'
import { readChatIfPossible } from '@/modules/chat'
import { widgetOptions } from '@/modules/options'
import { isClientConnected } from '@/modules/websocketClient/store'

import ContentList from './content/WidgetMessengerContentList.svelte'
import Header from './header/WidgetMessengerHeader.svelte'
import WidgetMessengerDragAndDrop from './input/WidgetMessengerDragAndDrop.svelte'
import WidgetMessengerInput from './input/WidgetMessengerInput.svelte'

onMount(() => {
	readChatIfPossible()
})

const { widgetBlockingOptions } = widgetOptions.getOptions()
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<div
	class="flex flex-col h-full bg-white"
	data-testid={testIds.widgetMessenger}
	ondragover={dragAndDrop.handleDragOver}
	ondrop={(e) => e.preventDefault()}
>
	{#if !widgetBlockingOptions?.headlessMode}
		<Header />
	{/if}
	<div class="flex flex-col flex-grow relative overflow-hidden" style:display={$dragAndDrop ? 'none' : 'inherit'}>
		<FlashMessageContainer />
		{#key $isClientConnected}
			<ContentList />
		{/key}
	</div>
	<div class="p-4 space-y-4" style:display={$dragAndDrop ? 'none' : 'block'}>
		<WidgetMessengerInput />
		{#if !widgetBlockingOptions?.headlessMode}
			<WidgetBranding />
		{/if}
	</div>

	<WidgetMessengerDragAndDrop />

	<DrawerManager />
</div>
